import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import CustomSlide from './customSlide/';
import Footer from '../../../../components/commonFooter/';
import HtmlRegion from '../../../../components/htmlRegion/';

const FooterPart = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const {
                content: { footer, cooperation, ad_middle_banner, ad_bottom_banner, gq_pic, bottom_videoPic },
            } = this.props;

            return (
                <div>
                    <Ad content={ad_middle_banner} styleName={styles.ad} />
                    <CustomSlide content={gq_pic} title="高清图片" mode="mix" />
                    <Chip id="55032" type="recommend" title="视频" groupName="底部" content={bottom_videoPic}>
                        <CustomSlide content={bottom_videoPic} title="视频" mode="pure" />
                    </Chip>
                    <Chip id="25014" type="static" title="合作链接" groupName="底部" content={cooperation}>
                        <HtmlRegion />
                    </Chip>
                    <Ad content={ad_bottom_banner} styleName={styles.ad} />
                    <Chip id="20036" type="struct" title="全站通用页尾导航" groupName="底部" content={footer}>
                        <Footer />
                    </Chip>
                </div>
            );
        }
    },
);

export { FooterPart };
export default FooterPart;
